'use client';

import * as React from 'react';
import {cn} from '@purpose/ui/lib/utils';

interface CategoryButtonProps {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  name: string;
  onClick?: (() => void) | null;
  className?: string;
  sx?: any;
}

const CategoryButton = React.forwardRef<HTMLButtonElement, CategoryButtonProps>(
  ({Icon, name, onClick, className, sx}, ref) => {
    return (
      <button
        aria-label="Kategori"
        ref={ref}
        onClick={onClick || undefined}
        className={cn(
          'flex flex-col items-center justify-center gap-4 rounded-lg p-[14px] lg:flex-row',
          'bg-card border-border hover:bg-accent hover:text-accent-foreground border',
          'cursor-pointer transition-colors duration-200',
          'text-foreground w-full',
          className
        )}
        style={sx}
      >
        <div className="flex h-8 w-8 items-center justify-center">
          <Icon className="text-foreground h-8 w-8" />
        </div>
        <span className="text-card-foreground max-w-[120px] text-center text-sm font-medium lg:text-left">
          {name}
        </span>
      </button>
    );
  }
);

CategoryButton.displayName = 'CategoryButton';

export {CategoryButton};
export type {CategoryButtonProps};
